<template>
  <div class="login">
    <b-button id="loginBtn" class="login-btn" variant="primary" @click="signIn">
        <b-icon scale="1.3" shift-v="-2" shift-h="-7" icon="cloud-fill"> </b-icon>  | Log In with <strong>Stryker SSO</strong>
      </b-button>
  </div>
</template>

<script>
export default {
  methods: {
    async signIn(){
      await this.$msal.signIn();
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.login-btn {
  width: 20rem;
  text-align: left;
  padding: .4rem 1.5rem

}
.login {
    position: fixed;
    top: 50%;
    left: 40%;
}
</style>